<template>
  <div class="banner">
    <h3>溯源新闻</h3>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.banner {
  position: relative;
  width: 100%;
  height: 5rem;
  background: url('../../../assets/images/news_banner.jpg') no-repeat;
  background-size: 100% 5rem;
  h3 {
    position: absolute;
    top: 1.4rem;
    left: 5.325rem;
    font-weight: normal;
    font-size: 0.625rem;
    color: #fff;
  }
}
</style>
